import { useApp } from "../context";
import { api, apiError } from "../lib/api";

export function ResetPassword({ user, reload }) {
  const { notify, closeModal } = useApp();
  const submit = async e => {
    e.preventDefault();
    try {
      await api.post(`/admin/users/${user.id}/password`, { password: new FormData(e.target).get("password") });
      closeModal();
      notify(`Password reset for ${user.email}. Share it with them securely.`);
      reload();
    } catch (err) {
      notify(apiError(err));
    }
  };
  return (
    <>
      <h2>Reset password</h2>
      <p>{user.name} · {user.email}</p>
      <form onSubmit={submit} data-testid="reset-password-form">
        <label>New password (min 8 characters)
          <input name="password" type="password" minLength={8} required autoComplete="new-password" data-testid="reset-password-input" />
        </label>
        <div className="footer">
          <button type="button" onClick={closeModal} data-testid="reset-password-cancel-btn">Cancel</button>
          <button type="submit" className="primary" data-testid="reset-password-save-btn">Save password</button>
        </div>
      </form>
    </>
  );
}

export function DeleteUser({ user, reload }) {
  const { notify, closeModal } = useApp();
  const confirm = async () => {
    try {
      await api.delete(`/admin/users/${user.id}`);
      closeModal();
      notify(`Deleted ${user.email}.`);
      reload();
    } catch (err) {
      notify(apiError(err));
    }
  };
  return (
    <>
      <h2>Delete this account?</h2>
      <p>{user.name} · {user.email} will no longer be able to sign in. This cannot be undone.</p>
      <div className="footer">
        <button onClick={closeModal} data-testid="delete-user-cancel-btn">Cancel</button>
        <button className="danger" onClick={confirm} data-testid="delete-user-confirm-btn">Delete account</button>
      </div>
    </>
  );
}
